/** Helpers de tempo / filtros do Painel do Técnico. */

export function todayYmd(date = new Date()) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

export function formatShortWeekday(date = new Date()) {
  try {
    return date.toLocaleDateString('pt-BR', { weekday: 'short', day: '2-digit', month: 'short' });
  } catch {
    return todayYmd(date);
  }
}

export function parseTimeToMinutes(timeStr) {
  if (timeStr == null || timeStr === '') return null;
  if (typeof timeStr === 'string' && timeStr.includes(':')) {
    const [h, m] = timeStr.split(':').map(Number);
    if (Number.isNaN(h) || Number.isNaN(m)) return null;
    return h * 60 + m;
  }
  const date = new Date(timeStr);
  if (!Number.isNaN(date.getTime())) return date.getHours() * 60 + date.getMinutes();
  return null;
}

export function formatMinutesHhMm(totalMinutes) {
  if (totalMinutes == null || !Number.isFinite(totalMinutes) || totalMinutes < 0) return '00:00';
  const h = Math.floor(totalMinutes / 60);
  const m = Math.round(totalMinutes % 60);
  return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
}

export function calculateAttendanceMinutes(horaInicial, horaFinal) {
  const ini = parseTimeToMinutes(horaInicial);
  const fim = parseTimeToMinutes(horaFinal);
  if (ini == null || fim == null) return null;
  let diff = fim - ini;
  if (diff < 0) diff += 24 * 60;
  return diff;
}

export function calculateAttendanceTime(horaInicial, horaFinal) {
  const mins = calculateAttendanceMinutes(horaInicial, horaFinal);
  if (mins == null) return 'N/A';
  return formatMinutesHhMm(mins);
}

export function minutesToClock(mins) {
  if (mins == null || !Number.isFinite(mins)) return '—';
  const h = Math.floor(mins / 60) % 24;
  const m = Math.round(mins % 60);
  return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
}

/** Fechadas = mesma regra do painel direito do Roteiro. */
export function filterFechadas(routeScheduleData = []) {
  return (routeScheduleData || []).filter(
    (o) =>
      (o.Tipo === 'Roteirizado' && o.TB02122_HORAINI != null && o.TB02122_HORAINI !== '') ||
      o.Tipo === 'Não Roteirizado'
  );
}

export function isForaDoRoteiro(order) {
  return order?.Tipo === 'Não Roteirizado';
}

export function isConcluida(order) {
  return order?.TB02115_DTFECHA != null && String(order.TB02115_DTFECHA).trim() !== '';
}

export function statusLabelFromMon(status) {
  switch (status) {
    case 'em_servico':
      return 'Em serviço';
    case 'deslocamento':
      return 'Em rota';
    case 'ocioso':
      return 'Ocioso';
    case 'nao_alocado':
      return 'Não alocado';
    case 'finalizado':
      return 'Finalizado';
    default:
      return 'Roteiro de hoje';
  }
}

/** Forecast padrão igual RouteModal: amanhã (seg–qui) ou próxima segunda. */
export function defaultRouteForecastYmd(date = new Date()) {
  const currentDay = date.getDay();
  const year = date.getFullYear();
  const month = date.getMonth();
  const day = date.getDate();
  let target;
  if (currentDay >= 1 && currentDay <= 4) {
    target = new Date(year, month, day + 1);
  } else {
    const daysUntilMonday = currentDay === 0 ? 1 : 8 - currentDay;
    target = new Date(year, month, day + daysUntilMonday);
  }
  return todayYmd(target);
}
